import { useTranslation } from "react-i18next";


export function EstimateDetailFormData(formData:any, step:string = ''){
    let inspections:any[] = [];
    let quotes:any[] = [];
    let optionas:any[] = [];
    let selections:any[] = [];

    let error:any = {};

    /*============== CHECK ERROR =============*/
    //step1

    //step2

    //step3

    //step4

    //step5
    // if(!formData.optional){
    //     error['optional'] = "no data"
    // }
    selections = formData.selection ? [...formData.selection.selections] : [];

    [1,2,3].map(()=>{
        selections.push({name:"", customer:""})
    })

    selections = selections.map((item,index)=> {return  { fieldName:item.name ,  customerInput : item.customer,sortOrder:index}} )

    selections = selections.filter((i, index)=> index <= 2)
    //step6

    //step7

    /*============== CONVERT DATA =============*/
    //step3
    const inspectionFiles:any = {}
    if(formData.inspections){
        formData.inspections.map((inspection:any, index:number)=>{
            //console.log("inspection", inspection);
            let images:any = [];
            inspection.images.map((image:any, indexPhoto:number )=>{
                inspectionFiles[`inspectionImage_${index}_${indexPhoto}`] = image.file ? image.file : undefined;
                //console.log("image", image, image.id);
                images.push({
                    id : image.id && !image.file ? image.id : undefined,
                    description : image.description,
                    sortOrder : indexPhoto,
                })
            })
            inspections.push({
                id: inspection.id ? inspection.id : undefined,
                sectionTitle: inspection.sectionTitle,
                style: inspection.style ?? 0,
                images:images
            })
        })
    }

    //step4
    if(formData.quotes){
        formData.quotes.map((quote:any, index:number)=>{
            let quoteSections:any[] = [];

            quote.sections.map((section:any, sectionIndex:number)=>{
                quoteSections.push({
                    title: section.title,
                    isVisible: section.isVisible,
                    sectionItems: section.sectionItems.map((item:any,indexItem:number) =>({...item, sortOrder: indexItem} )),
                    sortOrder: sectionIndex
                })
            })

            quotes.push({
                profitMargin: Number(quote.quoteProfitMargin ?? formData.quoteProfitMargin ?? 0) * 100,
                note: quote.quoteNote ?? quote.note ?? null,
                sortOrder: index,
                quoteName: quote.quoteName,
                quoteSections: quoteSections,
            })
            // quotes.push({
            //     title: quote.title,
            //     isVisible: quote.isVisible,
            //     sectionItems: quote.sections.map((item:any,index:number) =>({...item, sortOrder: index} )),
            //     sortOrder: index
            // })
        })
    }

    //step5
    if(formData.optionas){
        formData.optionas.map((quote:any)=>{
            optionas.push({
                title: quote.title,
                isVisible: quote.isVisible,
                sectionItems: quote.sections
            })
        })
    }

    let data:any = {
        //common
        jobId: formData.jobId,
        lastStep: formData.lastStep,
        estimateLayoutId: 1,
        titleStep1: formData.titleStep1,
        titleStep2: formData.titleStep2,
        titleStep3: formData.titleStep3,
        titleStep4: formData.titleStep4,
        titleStep5: formData.titleStep5,
        titleStep6: formData.titleStep6,
        titleStep7: formData.titleStep7,

        //step1
        name: formData.name,
        estimateDate: formData.estimateDate ?? new Date(),

        companyName: formData.companyName,
        firstName: formData.firstName,
        lastName: formData.lastName,
        address: formData.address,
        city: formData.city,
        stateProvince: formData.stateProvince,
        zipCodePostalCode: formData.zipCodePostalCode,

        primaryImage: formData.primaryImage,// [PROXY]

        //step2     
        aboutUs: formData.usDescription,

        //step3
        inspections: inspections,
        ...inspectionFiles,

        //step4
        quotes: quotes,
        //step5
        disclaimer: formData.disclaimer,
        signerLayouts: [{...(formData.signer ? {
            firstName: '',
            lastName: '',
            email: '',
            ...formData.signer
        }:{
            firstName: '',
            lastName: '',
            email: '',
        }) , id: undefined}],
        isDeposit: formData.isDeposit,
        footerNotes: formData.footerNotes,
        productionSelection: {
            title: formData.selection?.title ?? "",
            selections: selections.slice(0,3)
        },

        optionalUpdates: {
            sectionItems:formData.optional ? formData.optional.sections.map((item:any,index:number) =>({...item, sortOrder: index} ))
            :[],
        },
        
        //step6
        termsNConditions:  formData.termsNConditions,

        //step7
        insuranceDetails: formData.insuranceDetails,
        isAcknowledged: "true"
    }

    return {data, error: Object.keys(error).length > 0 ? error : undefined };
}

export function EstimateFormData(responses:any) {
    if (!responses) {
        return {};
    }

    const sortByOder = (array:any[]) =>{
        if (!array || !Array.isArray(array)) return [];
        return [...array].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
    }

    let quotes = responses.quotes ?  responses.quotes.map((quote:any) => {
        let sections:any =  sortByOder((quote.sections ?? []).map((section:any)=>{
            return {
                title :section.title,
                isVisible :section.isVisible,
                sortOrder:section.sortOrder,
                sectionItems:  sortByOder((section.items ?? []).map((sectionItem:any)=>{
                    return {
                        uom:sectionItem.uom,
                        type:sectionItem.type,
                        itemName:sectionItem.itemName,
                        quantity:sectionItem.quantity,
                        unitPrice:sectionItem.unitPrice,
                        sortOrder:sectionItem.sortOrder,
                    }
                }))
            }
        }));
       
        return {
            quoteName:quote.quoteName,
            sections:sections,
            quoteProfitMargin: Number(quote.profitMargin ?? 0) / 100,
            note: quote.note ?? "",
            quoteNote: quote.note ?? "",
        }
    }) : [];

    const parsrSelection = (item:any) => {
        if(!item) return {
            name:"", 
            customer:"",
            sortOrder:0,
        }

        return {
            name:item.fieldName, 
            customer:item.customerInput,
            sortOrder:item.sortOrder,
        } 
    };
    

    let productionSelection:any = {}
    const selection = responses.productionSelection;
    productionSelection.title = selection?.title ?? "";
    productionSelection.selections = sortByOder([
        parsrSelection(selection?.productionSelection1),
        parsrSelection(selection?.productionSelection2),
        parsrSelection(selection?.productionSelection3),
    ])

    let optionalUpdates = {
        title :"",
        isVisible :"",
        sections: responses.optionalUpgrade?.items ? sortByOder(responses.optionalUpgrade.items.map((sectionItem:any)=>{
            return {
                uom:sectionItem.uom,
                type:sectionItem.type,
                itemName:sectionItem.itemName,
                quantity:sectionItem.quantity,
                unitPrice:sectionItem.unitPrice,
                sortOrder:sectionItem.sortOrder,
            }
        })) : []
    }

    let signer =  responses.signers && responses.signers[0] ?  
    responses.signers[0]
     : {
        firstName: '',
        lastName: '',
        email: '',
     };

    let inspections:any[] = [];
    responses.inspections && responses.inspections.map((inspection:any)=>{
        let imgs:any[] = [];
        (inspection.images ?? []).map((img:any)=>{
            imgs.push({
                id: img.id,
                sortOrder: img.sortOrder,
                description: img.description,
                fileUrl: img.image ? img.image.url : ""
            })   
        })
        inspections.push({
            id: inspection.id,
            images:imgs,
            sectionTitle: inspection.sectionTitle,
            style: inspection.style ?? 0,
        })
    })

    
    return {
        ...responses,
        estimateDate: responses.estimateDate ? new Date(responses.estimateDate) : new Date(),
        quoteNote: responses.quotes && responses.quotes[0] ? (responses.quotes[0].note ?? "") : "",
        quoteProfitMargin: responses.quotes && responses.quotes[0]
            ? Number(responses.quotes[0].profitMargin ?? 0) / 100
            : 0,
        quotes: quotes,
        usDescription:responses.aboutUs,
        inspections:inspections.length ? inspections : undefined,

        optional: optionalUpdates,
        selection: productionSelection,
        signer:signer,
    }
}

export function EstimateCheckValidate(t:any, formData:any, step:number){
    if(step == 0)
        return checkValidateStep1(t, formData)
    if(step == 1)
        return checkValidateStep2(t, formData)
    if(step == 2)
        return checkValidateStep3(t, formData)
    if(step == 3)
        return checkValidateStep4(t, formData)
    if(step == 4)
        return checkValidateStep5(t, formData)
    if(step == 5)
        return checkValidateStep6(t, formData)
    if(step == 6)
        return checkValidateStep7(t, formData)
    else return {}
}

// common
function checkRequired(error:any, t:any, formData:any, key:string) {
    if(!formData[key] || (Array.isArray(formData[key]) && formData[key].length == 0) ){
        error[key] = t(`estimate.form.${key}.required`)
    }
}

function checkEmail(error:any, t:any, formData:any, key:string) {
    if(!formData[key]) return;

    if( !(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData[key])) ){
        error[key] = t(`estimate.form.${key}.format`)
    }
}

function checkQuote(t:any, sections:any) {
    let error:any = {
        "_noError":true,
    }
    if(!sections || sections.length == 0 ){
        // error['sections'] = "Sections is required";
        // error['_noError'] = false;
    }
    else{
        let quotes:any[] = [];
        sections.map((item:any) => {
            let iError = {};
            checkRequired(iError, t, item, 'itemName');
            checkRequired(iError, t, item, 'uom');
            checkRequired(iError, t, item, 'quantity');
            checkRequired(iError, t, item, 'unitPrice');

            error['_noError'] = error['_noError'] && (Object.keys(iError).length == 0);
            quotes.push(iError);
        })

        error["sectionList"] = quotes;
    }
    return error;
}

function checkQuotes(t:any, quotes:any) {
    let error:any = { "_noError":true,}
    // kiêm tra quotes có item nào active
    if(!quotes || quotes.length == 0 ){
        // error['sections'] = "Quotes is required";
        //  error['_noError'] = false;
    }else{
        let quotesList:any = [];
        let hasActive = false;
        quotes.map((quote:any) => {
            if(quote.isVisible) hasActive= true;

            let iError = checkQuote(t, quote.sections);
            error['_noError'] = error['_noError'] && iError['_noError'];
            quotesList.push(iError)
        }, []);

        error['quotesList'] = quotesList
        if(!hasActive){
            error['sections'] = "Quotes require at least one active item.";
            error['_noError'] = false;
        }
    }

    return error;
}

function checkSigners(t:any, signers:any) {
    let error:any = {
        "_noError":true,
    }
    // kiêm tra quotes có item nào active
    if(!signers || signers.length == 0 ){
        // error['signers'] = "Quotes is required";
        // error['_noError'] = false;
    }else{
        let signersList:any = [];
        signers.map((item:any) => {
            let iError = {};
            // checkRequired(iError, t, item, 'firstname');
            // checkRequired(iError, t, item, 'email');
            checkEmail(iError, t, item, 'email');
            
            error['_noError'] = error['_noError'] && (Object.keys(iError).length == 0); 
            signersList.push(iError);
        }, []);
        error['signersList'] = signersList
    }

    return error;
}

// step
function checkValidateStep1(t:any, formData:any){
    let error = {};
    checkRequired(error, t, formData, 'name');
    // checkRequired(error, t, formData, 'estimateDate');
    // checkRequired(error, t, formData, 'primaryImage');
    // checkRequired(error, t, formData, 'companyName');
    // checkRequired(error, t, formData, 'firstName');
    // checkRequired(error, t, formData, 'lastName');
    // checkRequired(error, t, formData, 'address');
    // checkRequired(error, t, formData, 'city');
    // checkRequired(error, t, formData, 'stateProvince');
    // checkRequired(error, t, formData, 'zipCodePostalCode');
    return error;
}

function checkValidateStep2(t:any, formData:any){
    let error = {};
   // checkRequired(error, t, formData, 'usDescription');
    return error;
}

function checkValidateStep3(t:any, formData:any){
    let error:any = {
        '_noError':true
    };

    // if(formData.inspections && formData.inspections.length > 0) {
    //     console.log("formData",formData.inspections.length);
    //     let inspections:any = []
    //      for(let i = 0; i < formData.inspections.length; i++){
    //         let item = formData.inspections[i];
    //         let iError = {};
    //         checkRequired(iError, t, item, 'sectionTitle');
    //         checkRequired(iError, t, item, 'description');
    //         checkRequired(iError, t, item, 'file');

    //         error['_noError'] = (Object.keys(iError).length == 0) && error['_noError'];
    //         inspections.push(iError);
    //      }
    //     error["inspectionList"] = inspections;
    // }else{
    //     error["inspections"] = "Inspection is required"
    //     error['_noError'] = false;
    // }
    return error;
}

function checkValidateStep4(t:any, formData:any){
    let error:any = {};
    
    // checkRequired(error, t, formData, 'quoteNote');
    // checkRequired(error, t, formData, 'quoteProfitMargin');
    // // checkRequired(error, t, formData, 'quotes');

    // let noError =  (Object.keys(error).length == 0)

    // error['quotes'] = checkQuotes(t, formData.quotes);
    // error['_noError'] = noError && error['quotes']['_noError'];
    
    return error;
}

function checkValidateStep5(t:any, formData:any){
    let error:any = {};
    // checkRequired(error, t, formData, 'disclaimer');
    // //checkRequired(error, t, formData, 'signers');
    // checkRequired(error, t, formData, 'footerNotes');
    // //checkRequired(error, t, formData, 'optional');

    let noError =  (Object.keys(error).length == 0)

    //error['optional'] = checkQuote(t, formData.optional ? formData.optional.sections :[]);
    if(formData.signer) {
        checkRequired(error, t, formData.signer, 'firstName');
        checkRequired(error, t, formData.signer, 'lastName');
        checkRequired(error, t, formData.signer, 'email');
        checkEmail(error, t, formData.signer, 'email');
    }

    return error;
}

function checkValidateStep6(t:any, formData:any){
    let error = {};
  //  checkRequired(error, t, formData, 'termsNConditions');
    return error;
}

function checkValidateStep7(t:any, formData:any){
    let error = {};
   // checkRequired(error, t, formData, 'insuranceDetails');
    return error;
}